module.exports = __webpack_public_path__ + "static/media/arrow_drop_up-24px.e38e631d.svg";